import * as e from "react";
const l = (C) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...C
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.3341 9.99935C18.3341 5.39698 14.6032 1.66602 10.0008 1.66602C5.39844 1.66602 1.66748 5.39698 1.66748 9.99935C1.66748 14.6017 5.39844 18.3327 10.0008 18.3327C14.6032 18.3327 18.3341 14.6017 18.3341 9.99935ZM9.27944 6.07045C9.27944 5.40968 9.8151 4.87402 10.4759 4.87402C11.1366 4.87402 11.6723 5.40968 11.6723 6.07045C11.6723 6.73122 11.1366 7.26688 10.4759 7.26688C9.8151 7.26688 9.27944 6.73122 9.27944 6.07045ZM8.20801 9.28474C8.20801 8.82121 8.58377 8.44545 9.04729 8.44545H10.4759C10.7381 8.4462 10.9852 8.56946 11.1433 8.77864C11.3015 8.98781 11.3527 9.25887 11.2819 9.51135L10.1628 13.4455H10.4759C10.9394 13.4455 11.3152 13.8212 11.3152 14.2847C11.3152 14.7483 10.9394 15.124 10.4759 15.124H9.04729C8.78508 15.1233 8.53793 15 8.37981 14.7908C8.22169 14.5817 8.17042 14.3106 8.24122 14.0581L9.36035 10.124H9.04729C8.58377 10.124 8.20801 9.74826 8.20801 9.28474Z",
      fill: "#2D6DED"
    }
  )
);
export {
  l as default
};
